<!--
 * @Autor: lh
 * @Date: 2023-03-17 16:13:07
 * @LastEditors: lh
 * @LastEditTime: 2023-11-15 17:21:41
 * @Description: v2传送组件
-->
<script>
export default {
  props: {
    to: {
      type: String,
      // required: true,
      default:'#app'
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  // inject: ['parent'],
  watch: {
    disabled() {
      if(this.disabled) { // 把当前的DOM元素 向目标元素传送过去
        document.querySelector(this.to).appendChild(this.$el)
      }else { // 调用父组件的方法， 再将当前的DOM元素还原的原来的位置
        // this.parent && this.parent.toSourceDom(this.$el)
        this.$parent.toSourceDom(this.$el)
      }
    }
  },
  mounted(){
    if(this.disabled) document.querySelector(this.to).appendChild(this.$el)
  },
  /**
   *  render方法中，如果有变量得使用{}
   *  this.$scopedSlots.default() 表示预留一个插槽
   */
  render() {
    return <div class="Teleport">{this.$scopedSlots.default()}</div>
  }
}
</script>
<style scoped>
.Teleport {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/hongbao_new/common/telelop.vue